import {setStore} from '../../../../src/utility/setStore'
export default {
    SET_PARTNERS(state,data) {
        state.partners = data;
        //setStore('moduleName','Key',value)
        setStore('website','partners,list',data)
    },
    SET_PARTNER_STATUS(state,data) {
        state.partnerStatus = data;
        //setStore('moduleName','Key',value)
        setStore('website','partners,partnerStatus',data)
    },
    SET_CURRENT_PARTNER(state,data) {
        state.currentPartner = data;
        //setStore('moduleName','Key',value)
        setStore('website','partners,currentPartner',data)
    },
};
